export default __webpack_public_path__ + "static/media/gic120c.8384bdae.png";